/* eslint-disable menti-react/filename-convention--jsx */
import React from 'react';

interface QuizMetaContext {
  currentIndex: number;
  totalCount: number;
  isLastLeaderboard: boolean;
  leaderboardHasTimeBasedScoringBasedOnPreviousQuiz: boolean;
  follower: boolean;
}
const QuizMetaContext = React.createContext<QuizMetaContext>({
  currentIndex: 0,
  totalCount: 0,
  isLastLeaderboard: false,
  leaderboardHasTimeBasedScoringBasedOnPreviousQuiz: false,
  follower: false,
});
QuizMetaContext.displayName = 'quizMetaContext';

export const useQuizMetaContext = () => React.useContext(QuizMetaContext);

/**
 * Provider for meta data for the quiz which are unique for the quiz only.
 * It is optional as we don't need this data in for example public view.
 */
export const QuizMetaProvider = React.memo<{
  children: React.ReactNode;
  value: QuizMetaContext;
}>(({ children, value }) => {
  return (
    <QuizMetaContext.Provider value={value}>
      {children}
    </QuizMetaContext.Provider>
  );
});
QuizMetaProvider.displayName = 'QuizMetaProvider';
